import { fileTypeFromStream } from "file-type"

export function getElement(
  elementOrSelector: HTMLElement | string,
): HTMLElement | null {
  if (typeof elementOrSelector === "string") {
    return document.querySelector(elementOrSelector)
  }

  return elementOrSelector
}

export function getFormButtons(form: HTMLFormElement) {
  const formButtons = Array.from(form.querySelectorAll("button"))
  const formId = form.id
  if (formId) {
    formButtons.push(
      ...Array.from(
        document.querySelectorAll(
          `button[form=${formId}]`,
        ) as NodeListOf<HTMLButtonElement>,
      ),
    )
  }
  return formButtons
}

type Obj = {
  [key: string]: boolean | number | string
}
export function sortObject<O extends Obj = Obj>(obj: O): O {
  return Object.entries(obj)
    .sort(([key1], [key2]) => (key1 > key2 ? 1 : -1))
    .reduce((o, [key, value]) => {
      ;(o as Obj)[key] = value
      return o
    }, {} as O)
}

export async function getFileType(file: File): Promise<string | undefined> {
  /**
   * Need to check if the file is a JSON, CSV, TXT or XLS file
   * because fileTypeFromStream doesn't support these file types
   * and it returns undefined
   */

  let fileType = file.type

  if (fileType === "application/json") {
    fileType = "json"
  } else if (fileType === "text/csv") {
    fileType = "csv"
  } else if (fileType === "text/plain") {
    fileType = "txt"
  } else if (
    fileType === "application/vnd.ms-excel" // .xls
  ) {
    fileType = "xls"
  } else if (
    fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
  ) {
    fileType = "xlsx"
  } else if (fileType === "image/svg+xml") {
    fileType = "svg"
  } else {
    fileType = (await fileTypeFromStream(file.stream()))?.ext ?? fileType
  }

  return fileType
}